import axios from 'axios';

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || '/api',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor: agregar token JWT
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // FormData necesita boundary multipart; no forzar application/json.
    if (typeof FormData !== 'undefined' && config.data instanceof FormData) {
      const headers = config.headers;
      if (headers && typeof headers.delete === 'function') {
        headers.delete('Content-Type');
      } else if (headers) {
        delete (headers as Record<string, unknown>)['Content-Type'];
        delete (headers as Record<string, unknown>)['content-type'];
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor: manejar errores 401
// IMPORTANTE: NO navegar a /login aquí — dejar que el router guard lo maneje.
// El redirect forzoso rompe el flujo de initializeAuth() al recargar.
let clearing401 = false;
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401 && !clearing401) {
      // Solo limpiar sesión completa si había JWT (evita borrar pending OTP en flujos guest).
      const hadToken = Boolean(localStorage.getItem('token'));
      if (hadToken) {
        clearing401 = true;
        try {
          const { useAuthStore } = await import('@/store/auth');
          useAuthStore().clearSession();
        } catch {
          localStorage.removeItem('token');
          localStorage.removeItem('pending_email');
          delete api.defaults.headers.common['Authorization'];
        } finally {
          clearing401 = false;
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;
